import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative pt-16 md:pt-18 min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50 z-10"></div>
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20editorial%20design%20with%20dark%20dramatic%20gradient%20background%2C%20geometric%20shapes%20in%20fluorescent%20yellow-green%20and%20deep%20black%20with%20soft%20pink%20accents%2C%20clean%20artistic%20composition%2C%20high%20contrast%2C%20sophisticated%20magazine%20aesthetic%2C%20negative%20space%2C%20bold%20graphic%20elements&width=1800&height=900&seq=hero-bg-home-01&orientation=landscape"
        alt="51吃瓜网站 - 网红黑料每日大赛实时追踪"
        title="51吃瓜网站入口 - 网红黑料每日大赛实时追踪"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="relative z-20 w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-[40%] text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 leading-tight">
              网红黑料
              <br />
              <span className="font-serif italic text-accent-500">每日大赛</span>
              <br />
              实时追踪
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-md mx-auto lg:mx-0 leading-relaxed">
              一站式追踪全网热门吃瓜事件，每日更新网红黑料、塌房现场及吃瓜爆料视频，让你永远站在吃瓜第一线。
            </p>
            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/meiri-dasai"
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/category/chigua-baoliao"
                className="px-6 py-3 rounded-full border border-background-50/40 text-background-50 text-sm font-semibold hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看最新爆料
              </Link>
            </div>
          </div>
          <div className="w-full lg:w-[60%]">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20concept%20of%20digital%20media%20and%20breaking%20news%2C%20dark%20background%20with%20fluorescent%20yellow-green%20graphic%20elements%2C%20modern%20magazine%20layout%20aesthetic%2C%20bold%20geometric%20composition%2C%20dramatic%20contrast%2C%20clean%20minimal%20design%20with%20artistic%20flair&width=900&height=600&seq=hero-side-home&orientation=landscape"
                alt="51吃瓜网站在线观看 - 全网热门吃瓜事件"
                title="51吃瓜网站在线观看 - 全网热门吃瓜事件"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}